import { useApiQuery } from "./use-api-query.ts";

export function useRunsCiRunIds() {
  return useApiQuery<string[]>("/runs/ci-run-ids", {
    staleTime: 60 * 1000, // Cache for 1 minute
  });
}
